
import { Box, Flex, Link, Text } from "@chakra-ui/react"
import Icon from "components/UI/atoms/Icon"
import Button from "components/UI/atoms/Button"
import { useUI } from "providers/UIProvider"
import { useReportsContext } from "providers/ReportsProvider/ReportsProvider"


const DownloadReport = () => {
  const { T } = useUI()
  const { reportName, clearReport, handleDownloadReport } = useReportsContext()

  return (
    <Flex gap={2} w={"100%"} mt={"40px"} flexDirection={"row"} alignItems="center" >
      <Flex alignItems={"center"} justifyContent="center" h={"80px"} width={"50%"} borderRadius={"40px"} backgroundColor="#E9F2FD" >
        {reportName ? (
          <>
            <Text fontSize={"14px"}>{T("extract_report.report_generated")}:</Text>
            <Flex as="button" onClick={handleDownloadReport}>
              <Link color={"primary"} mr="5px">{reportName}</Link>
              <Icon name="file_csv" iconStyles={{ width: "20px", height: "20px", fill: "var(--chakra-colors-success)" }} />
            </Flex>
            <Box as="button" ml="10px" onClick={clearReport}>
              <Icon name="delete" iconStyles={{ width: "20px", height: "20px", fill: "var(--chakra-colors-error)" }} />
            </Box>
          </>
        ) : <Text>{T("extract_report.report_not_generated")}</Text>}
      </Flex>
      <Box >
        <Button
          text={T("actions.download")}
          onClick={handleDownloadReport}
          variant="success"
          styles={{ width: "280px", height: "80px", fontSize: "18px" }}
          leftIcon={
            <Icon
              name="download"
              iconStyles={{
                width: "34px",
                height: "34px",
                fill: "white",
              }}
            />
          }
          _hover={{ backgroundColor: "#08BA36" }}
          isDisabled={!reportName}
        />

      </Box>
    </Flex>
  )
}

export default DownloadReport
